import { getCVSDocuments } from "@/utils/apiFunctions";

export default {
  data() {
    return {
      candidatecvsdata: [],
      showcvstab: false,
      showcvsmedia: false,
    };
  },
  methods: {
    async fetchCVSPreview(candidateId) {
      try {
        let payload = {
          candidateID: candidateId,
        };
        const res = await getCVSDocuments(payload);
        if (res.status === 200) {
          this.showcvstab = true;
          this.candidatecvsdata = res.data.data.data;
        } else if (res.status == 404) {
          this.showcvstab = false;
        }
      } catch (err) {
        console.error("Failed to fetch CVS preview", err);
      }
    },
  },
};
